module.exports = __webpack_public_path__ + "static/media/social-stackoverflow.05011c37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-stackoverflow.svg
// module id = 95
// module chunks = 0